import {
  Avatar,
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Link,
  makeStyles,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import clsx from "clsx";
import { motion } from "framer-motion";
import Qrcode from "qrcode.react";
import React, { useEffect, useState } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import { useHistory, useLocation } from "react-router-dom";
import ReactStoreBadges from "react-store-badges";
import { StringParam } from "serialize-query-params";
import { useQueryParam } from "use-query-params";
import { slideRight, slideUp } from "util/transitions";
import { useStyles as baseCardStyles } from "../MedicalId/index";
import * as htmlToImage from "html-to-image";
import FileSaver from "file-saver";
import corporateHealthService from "services/corporate-health.service";
import { useQRCode } from "react-qrcodes";

const useStyles = makeStyles((theme) => ({
  centered: {
    justifyContent: "center",
    backgroundColor: theme.palette.background.card,
  },
  pass_container: {
    display: "grid",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      gridTemplateRows: "1fr",
      gridTemplateAreas: `"main" "qr" "footer"`,
    },
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr",
    gridTemplateAreas: `"qr main" "qr footer"`,
  },
  pass_header: {
    gridArea: "main",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  pass_sidebar: {
    gridArea: "qr",
  },
  pass_footer: {
    gridArea: "footer",
    textAlign: "center",
  },
  mobileStore: {
    "& > *": {
      marginRight: theme.spacing(2),
    },
  },
  companyLogo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& > img": {
      height: theme.spacing(7),
    },
  },
  largePhoto: {
    "& > div": {
      width: theme.spacing(10),
      height: theme.spacing(10),
      border: `solid ${theme.palette.primary.main}`,
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  profileBlock: {
    textAlign: "center",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  qr: {
    display: "grid",
    placeItems: "center",
    width: "100%",
    padding: theme.spacing(3),
  },
  pointer: {
    cursor: 'pointer'
  },
  pass_qr: {
    backgroundColor: "#fff"
  }
}));

const HealthPass = () => {
  const [code, setCode] = useQueryParam("code", StringParam);
  const [hashId, setHashId]= useQueryParam("hash_id", StringParam);
  const [deepLink, setDeepLink]= useQueryParam("deep_link", StringParam);

  const classes = { ...useStyles(), ...baseCardStyles() };
  const history = useHistory();
  const location = useLocation();

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  const [oriHealthPass, setOriHealthPass] = useState();

  useEffect(() => {
    async function fetchHealthPass() {
      // const healthPass = location.state?.passDetails;
      if (!hashId) return
      const inv = await corporateHealthService.getCorporatePass(hashId);
      console.log("📢[index.js:41]:", inv);
      setOriHealthPass(inv);
    }
    fetchHealthPass();
  }, [hashId]);

  const [inputRef] = useQRCode({
    text: hashId??"b",
    options: {
      quality: 1,
      level: 'M',
      margin: 2,
      scale: 4,
      width: 500,
      
    },
  });

  const captureQR = async () => {
    const captureBlock = document.getElementById("captureblock");
    const deeplink = document.getElementById('deeplink')
    
    const capture = await htmlToImage.toPng(captureBlock, {
      backgroundColor: "#FFF",
      cacheBust: true,
      filter: (node) => {
        return node !== deeplink
      }
    });
    FileSaver.saveAs(capture, "ZennyaQRCode.png");
  };

  return (
    <motion.div {...(isMobile ? slideRight : slideUp)}>
      <Container fixed maxWidth="md">
        <Card>
          <CardContent>
            <Box id="captureblock" className={clsx(classes.pass_container)}>
              <Box
                gridArea="main"
                className={clsx(classes.pass_header, "pass_header")}
              >
                <Grid
                  justify="center"
                  alignItems="center"
                  container
                  spacing={2}
                >
                  <Grid item xs={12} className={classes.companyLogo}>
                    <img
                      alt="company logo"
                      src={oriHealthPass?.company?.logo_url}
                    />
                  </Grid>
                  <Grid className={classes.largePhoto} item md={12} xs={3} sm={3}>
                    <Avatar src={oriHealthPass?.employee?.photo_url} />
                  </Grid>
                  <Grid item md={12} xs={9} sm={9} className={classes.profileBlock}>
                    <Typography variant="h3">{`${oriHealthPass?.employee?.display_name}`}</Typography>
                    <Typography variant="h6">{oriHealthPass?.roles}</Typography>
                    <Typography variant="h6">{`ID Number: ${oriHealthPass?.employee?.card_number}`}</Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box gridArea="qr" className={clsx(classes.pass_qr)}>
                {/* <Qrcode
                  bgColor="#fff"
                  fgColor="#111"
                  className={classes.qr}
                  value={hashId??""}
                  renderAs="canvas"
                  size={300}
                /> */}
                <img className={classes.qr} ref={inputRef}/>
              </Box>
              <Box
                gridArea="footer"
                className={clsx(classes.pass_footer, "pass_footer")}
              >
                <Box className={classes.profileBlock}>
                  <Link
                    className={classes.pointer}
                    onClick={(evt) => {
                      evt.stopPropagation();
                      captureQR();
                    }}
                  >
                    <Typography>Download your Zennya QR Code</Typography>
                  </Link>
                  <Link
                    onClick={(evt) => {
                      evt.stopPropagation();
                      FileSaver.saveAs(
                        "/assets/images/vaxprimer.png",
                        "vaxprimer.png"
                      );
                    }}
                    className={classes.pointer}
                  >
                  </Link>

                  <Typography variant="body2" gutterBottom>
                    Employee/dependent/third party will be notified via email
                    once they are scheduled for vaccination
                  </Typography>
                </Box>
                {(deepLink) ? (
                  <Link
                    href={deepLink}
                    target="_blank"
                    rel="noopener"
                    id="deeplink"
                  >
                    <Box>
                      <Typography>Open in app</Typography>
                      <img src="/assets/images/app.png" alt="zennyaapp" />
                    </Box>
                  </Link>
                ) : (
                  <></>
                )}
                {/* <Box className={clsx(classes.block, classes.mobileStore)}>
                  <ReactStoreBadges
                    platform={"ios"}
                    url={
                      "https://apps.apple.com/ph/app/zennya-health/id1040783089"
                    }
                  />
                  <ReactStoreBadges
                    platform={"android"}
                    url={
                      "https://play.google.com/store/apps/details?id=com.zennya.zennya&hl=en_US&gl=US"
                    }
                  />
                </Box> */}
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </motion.div>
  );
};

export { HealthPass };
